<template>
  <div class="contactBoxWrap">
    <div class="midSvg">
      <IconBase :viewBox="'0 0 22.001 18'">
        <mailTo></mailTo>
      </IconBase>
    </div>
    <div class="midDesWrap">
      <a href="mailto:info@msk.finmoll.com">info@msk.finmoll.com</a>
      <p>c 9:00 до 21:00, без выходных</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "email",
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      mailTo: () => import('@/components/svg/mailTo'),
    }
  }
</script>

<style scoped>
  .contactBoxWrap{display: flex;align-items: flex-start;justify-content: space-between}
  .midSvg {width: 7.9vw;height: 7.9vw;}
  a {color: #202020;text-decoration: none;font-weight: bold;font-size: 5vw;}
  p {color: #899193;font-size: 3.8vw;}
  .midDesWrap{width: calc(100% - 11.5vw);margin-left: 0.7vw;}

  @media screen and (min-width: 760px) {
    .contactBoxWrap{}
    .midSvg {width: 2.3vw;height: 2.3vw;}
    a {font-size: 1.4vw;}
    p {font-size: 1.1vw;}
    .midDesWrap{width: calc(100% - 2.3vw);margin-left: 0.7vw;}
  }
  @media screen and (min-width: 1140px) {
    .midSvg {width: 25px;height: 25px;}
    .midDesWrap{width: calc(100% - 25px);margin-left: 8px;}
    a {font-size: 16px;}
    p {font-size: 12px;}
  }
</style>
